<template>
	<div class="SplideWrapper" :class="{ heightAuto, avoidWide }">
		<SectionWrapper :title="title" :description="description" :wrapContentWithPadding="false"
			:imageOpacity="imageOpacity" :backgroundImage="backgroundImage" :useGradientBackground="useGradientBackground"
			:backgroundImagePositionX="backgroundImagePositionX" :backgroundImagePositionY="backgroundImagePositionY">
			<Splide :options="sliderOptions">
				<SplideSlide
					v-for="({ shortId, tornament, vs, name, location, date, image, score, link, ext, path, label, ...rest }, itemIndex) in items || []"
					:key="`shorts-${itemIndex}`">
					<template v-if="type === 'Shorts'">
						<iframe v-if="shortId" class="Short Video" loading="lazy"
							:src="`https://www.youtube-nocookie.com/embed/${shortId}?controls=0&modestbranding=1&rel=0&showinfo=0`"
							frameborder="0" :width="contentSize.width ? contentSize.width : 231"
							:height="contentSize.height ? contentSize.height : 410" allowfullscreen />

						<div v-else-if="vs" class="EventBox" @click="handleRedirectTo(link)"
							:style="{ cursor: link ? 'pointer' : 'default', width: '315px', height: '420px' }">
							<div class="EventInfo">
								<h6 class="Name">
									<template v-if="vs">vs {{ vs }}</template>
									<template v-if="name">{{ name }}</template>
									<br />

									<span class="Tornament">{{ tornament }}</span>
								</h6>
							</div>
							<div v-if="link" class="Finalized">
								<Icon icon="play" :size="40" color="white" />
							</div>

							<div class="Shadow">
								<div class="Date">
									<p class="Month">
										{{ formatDate(date).month }}
									</p>
									<p class="Day">
										{{ formatDate(date).day }}
									</p>
								</div>
								<div>
									<div v-if="score" class="Score">
										<Icon icon="bar-chart-2" :size="20" color="primary" />
										<p><b>{{ score }}</b></p>
									</div>
									<div v-else class="Time">
										<Icon icon="clock" :size="20" color="primary" />
										<p>{{ formatDate(date).time }}</p>
									</div>
									<div class="Location">
										<Icon icon="map-pin" :size="20" color="primary" />
										<p>{{ location }}</p>
									</div>

								</div>
							</div>
							<div class="EventImage"
								:style="{ backgroundImage: image ? `url(${require(`@/assets/imgs/${image}`)})` : `url(${require(`@/assets/imgs/${randomImages[Math.floor(Math.random() * randomImages.length)]}`)})` }">
							</div>
						</div>
					</template>

					<div v-else-if="type === 'CollageByFolder'" class="EventBox noBorder">
						<div class="EventBoxWrapper">
							<div class="GlobalYear">
								<div class="Year">
									{{ rest[0].year }}
								</div>
							</div>
							<div class="EventBoxContent" v-for="({ folder, year, ext: extension }) in rest"
								:key="`EventBoxContent-${folder}-${year}`">

								<div class="EventImage OpacityFull"
									:style="{ backgroundImage: `url(${require(`@/assets/imgs/history/${folder}/${year}${extension ? extension : '.jpg'}`)})` }">
									<!-- , star, hito, award, location: itemLocation -->
									<!-- <div class="Hito LightShadow">
										<div v-if="itemLocation" class="Location">
											<Icon icon="map-pin" :size="20" color="white" />
											<p>{{ itemLocation }}</p>
										</div>
										<div v-if="star" class="Location">
											<Icon icon="star" :size="20" color="white" />
											<p>{{ star }}</p>
										</div>
										<div v-if="award" class="Location">
											<Icon icon="award" :size="20" color="white" />
											<p>{{ award }}</p>
										</div>
										<div v-if="hito" class="Location">
											<p>{{ hito }}</p>
										</div>
									</div> -->
								</div>

								<!-- <div class="LightShadow">
									<div class="Year">
										<p class="Day">
											{{ year }}
										</p>
									</div>
									<div class="Hito">
										<div v-if="itemLocation" class="Location">
											<Icon icon="map-pin" :size="20" color="white" />
											<p>{{ itemLocation }}</p>
										</div>
										<div v-if="star" class="Location">
											<Icon icon="star" :size="20" color="white" />
											<p>{{ star }}</p>
										</div>
										<div v-if="award" class="Location">
											<Icon icon="award" :size="20" color="white" />
											<p>{{ award }}</p>
										</div>
										<div v-if="hito" class="Location">
											<p>{{ hito }}</p>
										</div>
									</div>
									<div>
									</div>
								</div> -->
								<!-- <div class="GlobalYear">
									<div class="Year">
										{{ year }}
									</div>
								</div> -->
							</div>



						</div>
					</div>
					<div v-else-if="type === 'Collage'" class="EventBox noBorder">
						<div class="EventBoxWrapper">
							<div class="GlobalYear">
								<div class="Year">
									{{ rest[0].year }}
								</div>
							</div>
							<div class="EventBoxContent" v-for="({ year, ext: extension }, yearIndex) in rest"
								:key="`EventBoxContent-${itemIndex}-${yearIndex}-${year}`">

								<div class="EventImage OpacityFull"
									:style="{ backgroundImage: `url(${require(`@/assets/imgs/history/${year}_${yearIndex}${extension ? extension : '.jpg'}`)})` }">
									<!-- , star, hito, award, location: itemLocation -->
									<!-- <div class="Hito LightShadow">
										<div v-if="itemLocation" class="Location">
											<Icon icon="map-pin" :size="20" color="white" />
											<p>{{ itemLocation }}</p>
										</div>
										<div v-if="star" class="Location">
											<Icon icon="star" :size="20" color="white" />
											<p>{{ star }}</p>
										</div>
										<div v-if="award" class="Location">
											<Icon icon="award" :size="20" color="white" />
											<p>{{ award }}</p>
										</div>
										<div v-if="hito" class="Location">
											<p>{{ hito }}</p>
										</div>
									</div> -->
								</div>

								<!-- <div class="LightShadow">
									<div class="Year">
										<p class="Day">
											{{ year }}
										</p>
									</div>
									<div class="Hito">
										<div v-if="itemLocation" class="Location">
											<Icon icon="map-pin" :size="20" color="white" />
											<p>{{ itemLocation }}</p>
										</div>
										<div v-if="star" class="Location">
											<Icon icon="star" :size="20" color="white" />
											<p>{{ star }}</p>
										</div>
										<div v-if="award" class="Location">
											<Icon icon="award" :size="20" color="white" />
											<p>{{ award }}</p>
										</div>
										<div v-if="hito" class="Location">
											<p>{{ hito }}</p>
										</div>
									</div>
									<div>
									</div>
								</div> -->
								<!-- <div class="GlobalYear">
									<div class="Year">
										{{ year }}
									</div>
								</div> -->
							</div>



						</div>
					</div>

					<div v-else-if="type === 'Events'" class="EventBox">
						<div class="EventInfo">
							<h6 class="Name">
								<template v-if="vs">vs {{ vs }}</template>
								<template v-if="name">{{ name }}</template>
								<br />

								<span class="Tornament">{{ tornament }}</span>

							</h6>
						</div>
						<!-- `linear-gradient(rgba(51, 51, 51, .4), rgba(51, 51, 51, .4)), url(${require(`@/assets/imgs/${image}`)})`
-->
						<div class="EventImage"
							:style="{ backgroundImage: image ? `url(${require(`@/assets/imgs/${image}`)})` : `url(${require(`@/assets/imgs/${randomImages[Math.floor(Math.random() * randomImages.length)]}`)})` }" />
						<div class="Shadow">
							<div class="Date">
								<p class="Month">
									{{ formatDate(date).month }}
								</p>
								<p class="Day">
									{{ formatDate(date).day }}
								</p>
							</div>
							<div>
								<div class="Time">
									<Icon icon="clock" :size="20" color="primary" />
									<p>{{ formatDate(date).time }}</p>
								</div>
								<div class="Location">
									<Icon icon="map-pin" :size="20" color="primary" />
									<p>{{ location }}</p>
								</div>
							</div>
						</div>
					</div>

					<div v-else-if="type === 'Images'" class="EventBox">
						<div v-if="label" class="Shadow">
							<div class="TitleWrapper">
								<p class="Title">
									{{ label }}
								</p>
							</div>
						</div>
						<div class="EventImage OpacityFull"
							:style="{ backgroundImage: `url(${require(`@/assets/imgs${path}/${image}${ext ? ext : '.jpg'}`)})` }">
						</div>
					</div>
				</SplideSlide>
			</Splide>
		</SectionWrapper>
	</div>
</template>

<script>
import VueTypes from 'vue-types'
import { mediaQueryMixin } from "@/mixins";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import moment from "moment";
import SectionWrapper from '../SectionWrapper/SectionWrapper.vue'
import { randomImages } from '@/utils/publicData'

export default {
	name: 'SplideWrapper',
	components: {
		Splide,
		SplideSlide,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			randomImages,
		};
	},
	props: {
		type: VueTypes.string,
		title: VueTypes.string,
		description: VueTypes.string,
		items: VueTypes.array,
		heightAuto: VueTypes.bool,
		contentSize: VueTypes.object,
		backgroundImage: VueTypes.string,
		imageOpacity: VueTypes.number,
		useGradientBackground: VueTypes.bool,
		avoidWide: VueTypes.bool,
		useArrows: VueTypes.bool,
		backgroundImagePositionX: VueTypes.string,
		backgroundImagePositionY: VueTypes.string,
		autoWidthProp: VueTypes.bool,
		customSpliderOptions: VueTypes.object,
	},
	computed: {
		isMobile() {
			return this.$mq.w < this.$mq.sm.min;
		},
		isTablet() {
			return this.$mq.w < this.$mq.md.min;
		},
		perPage() {
			if (this.isMobile) return 1;
			else if (this.isTablet) return 1;
			else return 3;
		},
		sliderOptions() {
			return {
				perMove: 1,
				width: "100%",
				gap: "2rem",
				perPage: this.perPage,
				pagination: true, //false,
				autoplay: true,
				interval: 8000,
				type: "loop",
				start: 2,
				arrows: this.useArrows,
				focus: 'center',
				autoWidth: this.autoWidthProp,
				...this.customSpliderOptions,
			};
		},
	},
	methods: {
		formatDate(date) {
			return {
				day: moment(date).utc().locale("es").format("D"),
				month: moment(date).utc().locale("es").format("MMMM"),
				time: moment(date).utc().local().locale("es").format("LT"),
			};
		},

		isPastDate(date) {
			const today = moment();
			return moment(date).isBefore(today);
		},
		handleRedirectTo(link) {
			console.log(link)
			if (link) window.open(link, "_blank");
		},
	},
}
</script>

<style lang="scss" scoped>
.SplideWrapper {
	width: 100%;

	&::v-deep .SectionWrapper {
		padding-bottom: 4rem;
	}

	&.heightAuto {

		.Short,
		.EventBox {
			border-radius: 20px;
			border: 5px solid rgba(white, 0.1);
			box-shadow: 0 2px 5px 0 rgba(black, 0.1);

			&.noBorder {
				border: none;
				box-shadow: none !important;
				overflow: visible !important;
			}
		}


		&::v-deep .splide__track {

			.splide__slide {
				height: auto;
				width: auto !important;
				box-shadow: none;
			}
		}
	}

	&.avoidWide {
		&::v-deep .splide__track {

			.splide__slide {
				width: 20rem !important;
			}
		}
	}

	&::v-deep .splide {
		width: 100%
	}

	&::v-deep .splide__track {
		padding: 0;

		.splide__list {
			align-items: center;
		}

		.splide__slide {
			height: 20rem;
			width: 26rem !important;
			transition: all 0.5s;
			box-shadow: 0px 0px 10px 5px rgba($black, 0.1);

			@media screen and (max-width: $sm) {
				height: 16rem;
				width: 95% !important;
			}
		}
	}


	&.latestEvents {

		.Short,
		.EventBox {
			border-radius: 20px;
			border: 5px solid rgba(white, 0.1);
			box-shadow: 0 2px 5px 0 rgba(black, 0.1);
		}

		&::v-deep .splide__track {

			.splide__slide {
				height: auto;
				width: auto !important;
			}
		}
	}

	.EventBox {
		height: 100%;
		position: relative;
		transition: all 0.3s ease-in-out;
		border-radius: 20px;
		overflow: hidden;
		background-color: #333;

		.EventInfo {
			z-index: 10;
			position: relative;

			.Name {
				color: white;
				font-size: 1.5rem;
				line-height: 1.5rem;
				padding: 25px;

				span.vs {
					font-size: 1rem;
					color: #ededed;
				}

				span.Tornament {
					font-size: 1rem;
					color: #ededed;
					font-weight: $font-weight-normal;
				}

			}
		}

		.EventImage {
			background-size: cover;
			background-repeat: no-repeat;
			background-position-x: center;
			background-position-y: center;
			height: 100%;
			width: 100%;
			opacity: 0.4;
			z-index: 0;
			position: absolute;
			top: 0;




			&.OpacityFull {
				opacity: 1;
			}
		}

		.EventBoxWrapper {
			min-height: 20rem;
			display: flex;
			flex-direction: column;
			gap: .5rem;
			width: 20rem;
			height: 80vh;

			@media screen and (min-width: $lg) {
				height: 40rem;
			}

			.GlobalYear {
				// position: absolute;
				// top: -2rem;
				// left: 50%; //calc(50% - 2rem); // 0;
				border-radius: 1rem; // 1rem 0 0;
				// background: $white !important;
				background: rgba(white, 0.1); // #999;
				padding: 8px 18px;
				// margin-right: 16px;

				// background: #999;
				//te amo
				// .Day {}
				.Year {
					font-weight: bold;
					font-size: 1.2rem;
					line-height: 1.2rem;
					text-align: center;

				}
			}

			.EventBoxContent {
				position: relative;
				height: 50%;
				border: 5px solid rgba(white, 0.1);
				box-shadow: 0 2px 5px 0 rgba(black, 0.1);
				border-radius: 20px;
				overflow: hidden;

				.EventImage {
					position: relative;

					.Hito * {
						position: absolute;
						bottom: 0px;
						left: 4px;
						color: white;
						width: 100%;
						text-align: center;
					}

				}
			}
		}

		.Finalized {
			position: absolute;
			top: 20px;
			right: 20px;
		}

		.Shadow,
		.NoShadow,
		.LightShadow {
			z-index: 1;
			position: absolute;
			background-image: linear-gradient(0deg, $body-color, transparent);
			bottom: 0;
			width: 100%;
			height: 50%;
			display: flex;
			align-items: flex-end;

			.Location,
			.Score,
			.Time {
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				p {
					color: #fff !important;
					margin: 0;
				}

				.Icon {
					margin-right: 15px;
				}
			}

			.Date,
			.TitleWrapper,
			.Year {
				background: #999;
				padding: 16px 24px;
				margin-right: 16px;

				.Month,
				.Title {
					font-size: 1rem;
					font-weight: bold;
					text-transform: uppercase;
				}

				.Day {
					text-align: center;
					font-size: 2rem;
				}
			}

			.TitleWrapper {
				border-radius: 0 1rem 0 0;
			}

			// .Year {
			// 	border-radius: 0 1rem 0 0;
			// 	padding: 8px 18px;

			// 	.Day {
			// 		font-weight: bold;
			// 		font-size: 1.5rem;
			// 		line-height: 1.5rem;
			// 	}
			// }


			.Location {
				margin-bottom: 20px;
			}
		}

		.LightShadow {

			height: 39.4%;
			background-image: none;
			// background-image: linear-gradient(0deg, rgba(#000, 1), transparent);
		}

		.NoShadow {
			background-image: none;
		}

		.Hito {

			.Location,
			.Score,
			.Time {
				.Icon {
					margin-right: 8px;
				}

				margin-bottom: 12px;
			}
		}

		.LightShadow {
			background-image: linear-gradient(0deg, rgba(#333, .5), transparent);

		}
	}
}
</style>
<style lang="postcss">
.splide__track {
	padding: 20px 0;
}

.splide__arrows {

	button {
		background: none !important;

		svg {
			width: 60px !important;
			height: 60px !important;
			fill: white !important;
		}
	}
}

.splide__pagination {
	bottom: -40px;
	width: 100%;
	z-index: 99;

	.splide__pagination__page {
		width: 10px !important;
		height: 10px !important;
	}
}
</style>
